import { Box } from '@coolblue-development/becky';
import { useEffect, useRef } from 'react';
import { useChatContext } from '../../../../../contexts/ChatContext';
import getCurrentTime from '../../../../../utils/timeFactory';
import ChatTab from '../ContactTab/ChatTab';
import { datadogLogs } from '@datadog/browser-logs';
import postEvent from '../../../../../services/postEvent';
import { useAppContext } from '../../../../../AppContext';

const ChatSidePanel = (): JSX.Element => {
  const { selectedChat, chatContacts } = useChatContext();
  const { agent } = useAppContext();
  const prevContactId = useRef<string | null>(null);

  useEffect(() => {
    const currentTime = getCurrentTime();

    if (prevContactId.current) {
      const previousTimestamp = localStorage.getItem(`contactFocusTimestamp`);

      if (previousTimestamp) {
        void postEvent(prevContactId.current, 'focus', {
          startedAt: new Date(JSON.parse(previousTimestamp) as Date),
          endedAt: currentTime
        }).catch((error: Error) => {
          const agentName = agent?.getName();
          datadogLogs.logger.warn('Failed to post focus event', { error, agent: agentName });
        });
      }
    }

    localStorage.setItem(`contactFocusTimestamp`, JSON.stringify(currentTime));

    prevContactId.current = selectedChat;
  }, [selectedChat]);

  return (
    <Box>
      {chatContacts?.map(contact => (
        <ChatTab key={contact} contactId={contact} />
      ))}
    </Box>
  );
};

export default ChatSidePanel;
